import { render, staticRenderFns } from "./RevenueTable.vue?vue&type=template&id=00d76cc8"
import script from "./RevenueTable.vue?vue&type=script&lang=js"
export * from "./RevenueTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports